module.exports = __webpack_public_path__ + "img/section-right-bg.55c0eb8f.png";